/**
 * 社内 SPA の起動（03 3.1）：/app-config.json を読む → Provider を組む → ルーター。
 * 設定が読めなければ INTERNAL_ERROR の文言を全画面に出す（03 1.3）。
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { errorText } from '@pcrm/shared';
import { loadRuntimeConfig } from './app/config/app-config';
import { AppProviders, createAppQueryClient } from './app/providers/AppProviders';
import { buildRoutes } from './app/router/routes';

const root_element = document.getElementById('root');
if (!root_element) {
  throw new Error('#root がありません');
}
const root = createRoot(root_element);

loadRuntimeConfig()
  .then((config) => {
    const router = createBrowserRouter(buildRoutes());
    root.render(
      <StrictMode>
        <AppProviders config={config} query_client={createAppQueryClient()}>
          <RouterProvider router={router} />
        </AppProviders>
      </StrictMode>,
    );
  })
  .catch(() => {
    root.render(
      <div role="alert" style={{ padding: 24, fontFamily: 'Roboto, "Noto Sans JP", sans-serif' }}>
        {errorText('INTERNAL_ERROR')}
      </div>,
    );
  });
